import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';

function shouldShowRemoveButton(
    activeStation,
    FSFLightBoxVisible,
    detailModeStation,
) {
    if (activeStation) {
        if (FSFLightBoxVisible) {
            if (detailModeStation === activeStation.id) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    } else {
        return false;
    }
}

function FSRemoveLightBoxContent(props) {
    const {
        FSFLightBoxVisible,
        activeStation,
        detailModeStation,
        onRemove,
        onAccept,
        onClose
    } = props;

    const showRemoveButton = shouldShowRemoveButton(
        activeStation,
        FSFLightBoxVisible,
        detailModeStation
    );

    return (
        <div className="fs-remove-light-box__content fs-remove-light-box-content">
            <p className="fs-remove-light-box-content__why-alignment">
                <Translation
                    tagName="b"
                    translationKey="fs-remove-light-box-why-alignment-prefix"
                />
                {' '}
                <Translation translationKey="fs-remove-light-box-why-alignment" />
                {' '}
            </p>

            <div className="fs-remove-light-box-content__actions">
                <Translation
                    tagName="button"
                    className="fs-remove-light-box-content__action-accept"
                    onClick={onAccept}
                    translationKey="fs-remove-light-box-header-action-accept"
                />

                {showRemoveButton &&
                    <Translation
                        tagName="button"
                        className="fs-remove-light-box-content__action-remove"
                        onClick={() => {
                            onRemove();
                        }}
                        translationKey="fs-remove-light-box-header-action-remove"
                    />
                }
            </div>

            {props.error && props.error.invalid && <p
                name="error-remove-fs"
                className="fs-remove-light-box-content__why-alignment floating-label-element__hint--invalid"
                style={{ border: 'none' }}
                dangerouslySetInnerHTML={toDangerousReactHtml(props.error.invalidMessage)}
                />
            }
        </div>
    );
}

FSRemoveLightBoxContent.propTypes = {
    expanded: PropTypes.bool.isRequired,
    FSFLightBoxVisible: PropTypes.bool.isRequired,
    detailModeStation: PropTypes.string,
    activeStation: PropTypes.object,
    error: PropTypes.object,
    onExpand: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { FSRemoveLightBoxContent };
